/**
 * 工作台河道洪峰数据状态管理
 * 由河道洪峰统计表组件获取数据，更新到state中；跑马灯中内容从state中获取
 */
import eventBus from "@/assets/util/eventBus";

export default {
  state: {
    riverInfo: [],
  },
  mutations: {
    updateRiverData(state, payload) {
      state.riverInfo = payload.data;
      eventBus.$emit("riverFloodUpdate");
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/workbench/index.js